import { atom } from "jotai";

/**
 * MN-8890 — true when usePrintStandardPlacementResize actually applied a per-size standard to at
 * least one placement (homogeneous, mapped order). The PDP notice reads this so it only promises
 * "resized for each garment size" when a resize is genuinely active — not for mixed/unmapped orders
 * the resolver defers (which would over-promise; flag-ON review feedback).
 */
export const standardPlacementResizeActiveAtom = atom(false);
